(ns pfo.document.controller
  (:require
   [pfo.api :as api  :refer [process-error]]
   [promesa.core :as p]
   [pfo.util :as util]
   [keechma.next.controller :as ctrl]
   #_:clj-kondo/ignore [taoensso.timbre :as timbre
                        :refer [log trace debug info warn error fatal report logf
                                tracef debugf infof warnf errorf fatalf reportf spy]]))

(derive :boir-document :keechma/controller)
(defmethod ctrl/handle :boir-document
  [{:keys [*state] :as ctrl} event arg]
  (case event
    :add (let [[{:keys [errors on-success]} params] arg]
           (->>
             (api/ajaxp "/document/boir/"
               {:params (util/remove-nil-values params)
                :method :post})
             (p/map (fn [response] (some-> on-success (apply [response]))))
             (process-error errors)))
    :file (let [[{:keys [errors on-success on-error]} params] arg]
           (->>
             (api/ajaxp "/boir/file"
               {:params (util/remove-nil-values params)
                :method :post})
             (p/map (fn [response] (some-> on-success (apply [response]))))
             (p/error (fn [e] (some-> on-error (apply [e])) (throw  e)))
             (process-error errors)))
    nil))

(derive :signature-status :keechma/controller)
(defmethod ctrl/handle :signature-status
  [{:keys [state*] :as ctrl} event arg]
  (case event
    :load (let [[{:keys [errors on-success]} params] arg]
            (->>
              (api/ajaxp (str "/occurrence/" (:occurrence_id params) "/signature/status/")
                {})
              (p/map (fn [response]
                       (ctrl/transact ctrl (fn [& _] (swap! state* assoc (:occurrence_id params) response)))
                       (some-> on-success (apply [response]))))
              (p/error (fn [e]
                         (if (= 404 (:status e))
                           (do
                             (ctrl/transact ctrl (fn [& _] (swap! state* assoc (:occurrence_id params) nil)))
                             (info "No signature for occurence" (:occurrence_id params)))
                           (throw e))))
              (process-error errors)))
    nil))

(derive :document-generate-summary :keechma/controller)
(defmethod ctrl/handle :document-generate-summary
  [_ctrl event {:keys [document-id]}]
  (case event
    :generate (->> (api/ajaxp (str "/documents/" document-id "/summary/") {:method :post})
                   (p/map (fn [response]
                             (util/set-location
                               (str "#/chat?"
                                    (util/make-params {:conversation_id (:conversation_id response)})))))
                   (process-error))
    nil))

(derive :document-ask-question :keechma/controller)
(defmethod ctrl/handle :document-ask-question
  [_ctrl event {:keys [document-id]}]
  (case event
    :start (->> (api/ajaxp (str "/documents/" document-id "/question/") {:method :post})
                (p/map (fn [response]
                          (util/set-location
                            (str "#/chat?"
                                 (util/make-params {:conversation_id (:conversation_id response)})))))
                (process-error))
    nil))

(derive :document-filter-choices :keechma/controller)
(defmethod ctrl/handle :document-filter-choices
  [{:keys [state*] :as ctrl} event arg]
  (case event
    :load (let [[{:keys [collection-ids
                         include-subcollections
                         on-success
                         errors]}] arg]
            (->>
              (api/ajaxp "/document/filter/"
                {:params (util/remove-nil-values
                           {:collection_id collection-ids
                            :include_subcollections include-subcollections})})
              (p/map (fn [response]
                       (ctrl/transact ctrl (fn [& _] (reset! state* response)))
                       (some-> on-success (apply [response]))))
              (process-error errors)))
    nil))
